export const getGoogleMapLink = (lat, lng) => (`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`);
